import { Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { ConfirmUser } from '../business/AccountBusiness';
import { Link } from 'react-router-dom';
import { PATHS } from '@routing/routes';
import { CheckCircleFilled } from '@ant-design/icons';
export const SignupConfirmation = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onFinish = () => {
    history.push('/booking/summary');
  };
  useEffect(() => {
    const fetchData = async () => {
      const token = new URLSearchParams(location.search).get('token');

      if (token) {
        await dispatch(ConfirmUser(token));
      }
    };
    fetchData();
  }, [dispatch, location.search]);

  return (
    <div className="App">
      <Form name="senderForm" onFinish={onFinish} layout="vertical">
        <Row justify="center" align="middle">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <br />
            <h3 className="center-text textColor normal-font">
              Your KFS online account has been successfully created.
              <br />
              <br />
              <span className="checkSignupConfirmationIcon">
                {' '}
                <CheckCircleFilled />
              </span>
              <br />
              <br />
              <Link to={PATHS.Login.path} className="normal-font center-text fs16px">
                <u>Click here to log in and book a pick up.</u>
              </Link>
            </h3>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
